"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeAdditionalParameterFromFiltersString = exports.removeAdditionalParameterFromFiltersPickedFromUrl = exports["default"] = void 0;
var parametersList = ["fbclid"];
var removeAdditionalParameterFromFiltersPickedFromUrl = function removeAdditionalParameterFromFiltersPickedFromUrl(pickedFilters) {
  pickedFilters.map(function (filter, index) {
    if (parametersList.find(function (parameter) {
      return parameter === filter;
    })) {
      pickedFilters.splice(index, 1);
    }
  });
  return pickedFilters;
};
exports.removeAdditionalParameterFromFiltersPickedFromUrl = removeAdditionalParameterFromFiltersPickedFromUrl;
var removeAdditionalParameterFromFiltersString = function removeAdditionalParameterFromFiltersString(filtersString) {
  // here I assume the additional parameter is always at the end of this string
  var chars = ["&", "?"];
  var correctedFiltersString = filtersString;
  parametersList.find(function (parameter) {
    var _char = chars.find(function (_char2) {
      return filtersString.indexOf("".concat(_char2).concat(parameter)) > -1;
    });
    if (_char) {
      var filtersStringArray = filtersString.split("".concat(_char).concat(parameter));
      correctedFiltersString = filtersStringArray[0];
    }
  });
  return correctedFiltersString;
};
exports.removeAdditionalParameterFromFiltersString = removeAdditionalParameterFromFiltersString;
var _default = removeAdditionalParameterFromFiltersPickedFromUrl; // function used to remove parameters added to url by Facebook
// later possibly also other analytic/marketing parameters
// removeAdditionalParameterFromFiltersPickedFromUrl
// needed because: these parameters cause filters to return empty result
// as the parameter is used as filter
// removeAdditionalParameterFromFiltersString
// needed because: last filter is removed when the parameter is added
exports["default"] = _default;